<template>
	<div class="about">
		<ThumbnailImage :image="modelImage" />
		<h2>Napsali o nás:</h2>
		<MessageBox color="green" signature="Alena Pecinová">
			Ocenili jsme především příjemnou a pečlivou komunikaci během tvorby návrhu
			zahrady, zohlednění vlastních představ a nápadů a užitečné rady pro
			vlastní realizaci. Moc se nám líbili nápadité kombinace rostlin s
			respektem k okolní krajině. Vřele doporučuji.
		</MessageBox>
		<MessageBox color="red" signature="David Klimek">
			Vyhovovala nám práce na návrhu zahrady, kdy jsme dostali několik variant k
			rozhodnutí. Vše probíhalo dle dohody a s profesionálním přístupem. Můžeme
			jenom doporučit.
		</MessageBox>
		<MessageBox color="special" withImage>
			<span><strong>Jitka Emlerová, DiS</strong></span>
			<p>
				Navrhuji zahrady a zahradní úpravy. 3D vizualizace zahrad připravuji v programu Realtime Landscaping Architect. Obor Zahradní a krajinná tvorba jsem absolvovala na VOŠZ v Mělníku. Řadu let jsem také vázala a aranžovala květiny, navrhovala a realizovala rostliny v interiérech.Pracuji na zakázku. Jsem součástí zahradní firmy ArboGard s.r.o, která zahrady realizuje.
			</p>
			<ul>
				<li><strong>jitka.emlerova@seznam.cz</strong></li>
				<li><strong>tel: 608 845 890</strong></li>
				<li><strong>IČO: 645 61 097</strong></li>
				<li><strong>DIČ: CZ7752020144</strong></li>
				<li><strong>bankovní spojení: 51-2658010247/0100 KB</strong></li>
			</ul>
			<img src="@/assets/img/woman.png" alt="Jitka Emlerová" />
		</MessageBox>
	</div>
</template>

<script>
import store from "@/store";
import ThumbnailImage from "@/components/ThumbnailImage";
import MessageBox from "@/components/MessageBox";
import modelImage from "@/assets/img/model.jpg";

export default {
	name: "about",
	components: {
		ThumbnailImage,
		MessageBox
	},
	data() {
		return {
			modelImage
		};
	},
	mounted() {
		const content = store.state.content[this.$attrs.id];
		store.changeNavigationData(content.title, content.text);
	}
};
</script>
